import { injectable } from 'inversify';
import { BaseSuperAgentRequestFactory, RequestSender } from '@studyportals/mb-platform-http-requests/base';
import { IRankingOrganisationSearchFilters, RankingApiClient } from '@studyportals/ranking-api-interface';

import { EventAggregationService } from '@/platform/EventAggregationService';
import { RequestInitiatedEvent } from '@/platform/events/RequestInitiatedEvent';
import { RequestCompletedEvent } from '@/platform/events/RequestCompletedEvent';
import { DomainApiProjectionOrganisationForSearch } from '@/infrastructure/DomainApiProjectionOrganisationForSearch';
import { OrganisationPresenter } from './OrganisationPresenter';
import { OrganisationSearchResult } from './OrganisationSearchResult';


@injectable()
export class RankingOrganisationPresenter extends OrganisationPresenter<IRankingOrganisationSearchFilters> {

	private readonly apiClient: RankingApiClient;

	public constructor(
		protected readonly eventAggregationService: EventAggregationService,
		protected readonly domainApiProjection: DomainApiProjectionOrganisationForSearch,
		window: Window
	) {
		super(eventAggregationService, domainApiProjection, window);

		this.apiClient = new RankingApiClient(
			CONFIG.RANKINGS_API_URL,
			new BaseSuperAgentRequestFactory(),
			new RequestSender()
		);
	}

	public async search(
		filters: IRankingOrganisationSearchFilters,
		resultSize: number,
		resultsOffset = 0
	): Promise<OrganisationSearchResult> {
		this.eventAggregationService.publish(new RequestInitiatedEvent());

		try {
			const response = await this.apiClient.getOrganisationCards(filters, resultSize, resultsOffset);
			const organisations = this.reconstituteAll(response.cards);

			return Promise.resolve({
				organisations,
				totalHits: response.totalHits,
			});
		} finally {
			this.eventAggregationService.publish(new RequestCompletedEvent());
		}
	}
}
